"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToPolicyDialogInteractor = void 0;
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
require("./loaders");
require("./components/AddToPolicyResultDialog/types");
class AddToPolicyDialogInteractor extends core_1.Interactor {
    constructor(instanceIds, loaders, listener, presenter) {
        super();
        this.instanceIds = instanceIds;
        this.loaders = loaders;
        this.listener = listener;
        this.presenter = presenter;
        this.subscriber = new rxjs_1.Subscription();
        this.didActivate = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.loaders.policyList.load();
                this.subscriber.add(this.loaders.policyList
                    .asObservable()
                    .pipe(operators_1.map((value) => value.selection[0]))
                    .subscribe((value) => this.onSelectedChange(value)));
            }
            catch (error) {
                this.presenter.showError(error);
            }
        });
        this.onAdd = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.selectedPolicyId) {
                return;
            }
            const selectedPolicyName = ((_a = this.loaders.policyList.getItemById(this.selectedPolicyId)) === null || _a === void 0 ? void 0 : _a.name) || '';
            try {
                this.presenter.addToPolicyLoadingState(true);
                yield this.loaders.addToPolicyAction.load({
                    selectedPolicyId: this.selectedPolicyId,
                    instanceIds: this.instanceIds,
                    selectedPolicyName,
                });
                const restData = this.loaders.addToPolicyAction.getValue();
                this.listener.onResultDialogActivate({
                    gridData: restData,
                    onDone: this.onDone,
                });
                this.presenter.addToPolicyDialogShowState(false);
            }
            catch (error) {
                this.presenter.showError(error);
            }
            finally {
                this.presenter.addToPolicyLoadingState(false);
            }
        });
        this.onDone = () => {
            var _a, _b;
            this.listener.onDeactivate();
            (_b = (_a = this.listener).onConfirm) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.onClose = () => {
            var _a, _b;
            this.listener.onDeactivate();
            (_b = (_a = this.listener).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.onCancel = () => {
            var _a, _b;
            this.listener.onDeactivate();
            (_b = (_a = this.listener).onCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.loaders = loaders;
        this.listener = listener;
        this.presenter = presenter;
        this.instanceIds = instanceIds;
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriber.unsubscribe();
        });
    }
    onSelectedChange(id) {
        this.presenter.addButtonDisabledState(!id);
        this.selectedPolicyId = id;
    }
}
exports.AddToPolicyDialogInteractor = AddToPolicyDialogInteractor;
//# sourceMappingURL=AddToPolicyDialogInteractor.js.map